import { ReactNode, useCallback } from "react";
import { RowsProps } from "../Table.props";

/**
 * @deprecated
 */
function Rows<T>(props: RowsProps<T>): JSX.Element {
  const { data, formattedData, handleRowClick, resetTable, testId } = props;

  const rowTestId = testId ? testId : "test__table";

  const renderRow = (obj: { [key: string]: string | number | ReactNode | null }, rowIndex: number): JSX.Element[] => {
    const objArray = Object.values(obj).map((item, index: number) => {
      return (
        <td key={`${item}-${index}`} data-testid={`${rowTestId}-row-${rowIndex}-col-${index}`}>
          {item}
        </td>
      );
    });

    return objArray;
  };

  // eslint-disable-next-line
  const rowClick = useCallback((e: any, data: any): void => {
    handleRowClick && handleRowClick(e, data);
    return;
  },
  [handleRowClick],
  );

  return (
    <>
      {formattedData.map((formattedRowData, index) => {
        return (
          <tr
            key={index}
            onClick={(e) => {
              resetTable();
              rowClick(e, data[index]);
            }}
            data-testid={`${rowTestId}-row-${index}`}
            role={handleRowClick ? "button" : ""}
          >
            {renderRow(formattedRowData, index)}
          </tr>
        );
      })}
    </>
  );
}

/**
 * @deprecated
 */
export default Rows;
